export default __webpack_public_path__ + "static/media/live-chat.d81d24fe.svg";